<script>
import abstractField from '../abstractField';
import { h, resolveComponent } from 'vue';

export default {
  name: 'field-checkbox',
  mixins: [abstractField],
  methods: {
    onChange($event) {
      this.schema.onChange(this.model, this.schema, $event);
    },
    onInput() {
      this.value = !this.value;
    }
  },
  render() {
    const legoCheckbox = resolveComponent('lego-checkbox');
    return h(
      legoCheckbox,
      {
        id: this.schema.id,
        disabled: this.schema.disabled,
        class: this.schema.fieldClasses,
        name: this.schemainputName,
        required: this.schema.required,
        value: this.value,
        checked: this.value,
        onClick: this.onChange,
        onInput: this.onInput
      },
      [this.schema.label]
    );
  }
};
</script>

<style lang="scss">
.c-form-group {
  .field-checkbox {
    padding-top: 6px;
  }
}
</style>
